// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accessherofirst {
  height: 273px;
  position: relative;
}

.accessherocontent1 {
  position: absolute;
  bottom: 0;
}

.accessherocontent3 {
  margin-left: 10px;
  width: 100%;
}

.accessherocontent4 {
  margin-left: 10px;
  width: 100%;
}

.accessherocontent5 {
  width: 100%;
}
@media (min-width: 320px) and (max-width: 890px) {
  .accessherofirst {
    position: static;
  }

  .accessherocontent1 {
    position: static;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 53px;
    width: 150%;
  }

  .accessherocontent2 {
    margin-left: 50px;
    width: 150%;
  }
}

.popup {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.popup-inner {
  position: relative;
  padding: 25px;
  margin-top: 3em;
  width: 600px;
  background: white;
  border-radius: 10px;
  /* text-align: center; */
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: red;
  color: white;
  border: none;
  padding: 8px;
  cursor: pointer;
}

.errorMessage {
  position: absolute;
  top: 21%;
  right: 10%;
}
`, "",{"version":3,"sources":["webpack://./src/components/doyenaccess.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ","sourcesContent":[".accessherofirst {\n  height: 273px;\n  position: relative;\n}\n\n.accessherocontent1 {\n  position: absolute;\n  bottom: 0;\n}\n\n.accessherocontent3 {\n  margin-left: 10px;\n  width: 100%;\n}\n\n.accessherocontent4 {\n  margin-left: 10px;\n  width: 100%;\n}\n\n.accessherocontent5 {\n  width: 100%;\n}\n@media (min-width: 320px) and (max-width: 890px) {\n  .accessherofirst {\n    position: static;\n  }\n\n  .accessherocontent1 {\n    position: static;\n    margin-left: 10px;\n    margin-right: 10px;\n    margin-top: 53px;\n    width: 150%;\n  }\n\n  .accessherocontent2 {\n    margin-left: 50px;\n    width: 150%;\n  }\n}\n\n.popup {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.popup-inner {\n  position: relative;\n  padding: 25px;\n  margin-top: 3em;\n  width: 600px;\n  background: white;\n  border-radius: 10px;\n  /* text-align: center; */\n}\n\n.close-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: red;\n  color: white;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n}\n\n.errorMessage {\n  position: absolute;\n  top: 21%;\n  right: 10%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
